import React from 'react';
import { SEO } from '../components/SEO';
export function TrustGuaranteesPage() {
  return <>
      <SEO title="Aspect — Trust & Guarantees" description="Aspect defines clear standards for verification, rights, and metadata across all imagery in the system." data-id="element-944" />
      <div className="space-y-24 md:space-y-32" data-id="element-945">
        {/* Intro */}
        <section className="max-w-2xl" data-id="element-946">
          <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-8 text-aspect-black" data-id="element-947">
            Trust & Verification
          </h1>
        </section>

        {/* What Verified Means */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-948">
          <div className="md:col-span-4" data-id="element-949">
            <span className="text-aspect-gray" data-id="element-950">Verification</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-951">
            <h2 className="text-2xl font-medium" data-id="element-952">What "Verified" Means</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-953">
              <p data-id="element-954">
                Verification confirms what is present in the image and where it
                came from.
              </p>
              <p data-id="element-955">It does not infer performance or endorsement.</p>
            </div>
          </div>
        </section>

        {/* Rights Model */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-956">
          <div className="md:col-span-4" data-id="element-957">
            <span className="text-aspect-gray" data-id="element-958">Rights</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-959">
            <h2 className="text-2xl font-medium" data-id="element-960">Rights Model</h2>
            <div className="space-y-4 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-961">
              <p data-id="element-962">
                Rights are secured at the project level and applied
                consistently.
              </p>
              <p data-id="element-963">No implied permissions. No retroactive clearance.</p>
            </div>
          </div>
        </section>

        {/* Metadata Requirements */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-964">
          <div className="md:col-span-4" data-id="element-965">
            <span className="text-aspect-gray" data-id="element-966">Metadata</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-967">
            <h2 className="text-2xl font-medium" data-id="element-968">Metadata Requirements</h2>
            <div className="space-y-6 text-aspect-black/80 leading-relaxed max-w-xl" data-id="element-969">
              <p data-id="element-970">Each asset includes:</p>
              <ul className="space-y-2 text-aspect-black/80" data-id="element-971">
                <li data-id="element-972">Project context</li>
                <li data-id="element-973">Product or system identification</li>
                <li data-id="element-974">Rights status</li>
                <li data-id="element-975">Attribution requirements</li>
              </ul>
              <p className="text-aspect-gray" data-id="element-976">
                Incomplete assets do not enter the system.
              </p>
            </div>
          </div>
        </section>

        {/* What Enters */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12" data-id="element-977">
          <div className="md:col-span-4" data-id="element-978">
            <span className="text-aspect-gray" data-id="element-979">Inclusion</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-980">
            <h2 className="text-2xl font-medium" data-id="element-981">What Enters the System</h2>
            <ul className="space-y-2 text-aspect-black/80 max-w-xl" data-id="element-982">
              <li data-id="element-983">Real projects</li>
              <li data-id="element-984">Real products</li>
              <li data-id="element-985">Real permissions</li>
            </ul>
          </div>
        </section>

        {/* What Is Excluded */}
        <section className="grid md:grid-cols-12 gap-8 md:gap-12 border-t border-aspect-gray/20 pt-12 pb-12" data-id="element-986">
          <div className="md:col-span-4" data-id="element-987">
            <span className="text-aspect-gray" data-id="element-988">Exclusion</span>
          </div>
          <div className="md:col-span-8 space-y-8" data-id="element-989">
            <h2 className="text-2xl font-medium" data-id="element-990">
              What Is Explicitly Excluded
            </h2>
            <ul className="space-y-2 text-aspect-gray max-w-xl" data-id="element-991">
              <li data-id="element-992">Speculative or staged imagery</li>
              <li data-id="element-993">Synthetic imagery</li>
              <li data-id="element-994">Unverified installations</li>
              <li data-id="element-995">Assets without documented rights</li>
            </ul>
          </div>
        </section>
      </div>
    </>;
}